module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Kefwxh/tc-custom/9781452152752.jpg?1700253325841",
      "alt": "This image is the cover for the book Happiness Is . . . 500 Ways to Be in the Moment"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Happiness Is . . . 500 Ways to Be in the Moment\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Mindful living is happy living. Discover five hundred ways to notice—and embrace—the best moments in life.")]), _c('br'), _c('br'), _vm._v("This refreshing book from the creators of "), _c('i', [_vm._v("Happiness Is. . . . ")]), _vm._v("illustrates five hundred inspiring ways to slow down, unplug, de-stress, connect with others, and relish the simple moments in life: sitting under a ceiling fan on a hot day, taking lunch away from your desk, letting go of negative thoughts, a beach yoga session, and more. "), _c('br'), _c('br'), _vm._v("Featuring charming illustrations and a friendly tone, this book sparks positive reflection and serves to remind us that happiness is all around—and within.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lisa Swerling, Ralph Lazar\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0